var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.view === 'list')?_c('ReportePagos',{on:{"mtdBack":_vm.mtdBack,"mtd_show":_vm.mtd_show_detail}}):_vm._e(),(_vm.view === 'detail')?_c('DetallePago',{attrs:{"reportData":_vm.selectedReport},on:{"mtdBack":function($event){_vm.view = 'list'}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }